import React, { Component, PropTypes } from "react";
import Panel from "../../../components/panel/Panel";
import cx from "classnames";
import { Button } from "react-bootstrap";

let disabled = "false",
  btnBackdisabled = false;
class StepFour extends Component {
  constructor(props) {
    super(props);
  }

  previousStep(e) {
    e.preventDefault();
    let fieldValues = this.props.saveValues();
    this.props.previousStep();
    disabled = "false";
  }

  componentWillMount() {
    const rehydrate = JSON.parse(localStorage.getItem("addNewSiteSavedState"));
    this.setState(rehydrate);
  }

  componentWillUnmount() {
    localStorage.setItem("addNewSiteSavedState", JSON.stringify(this.state));
  }

  render() {
    const sitedata = this.props.fieldValues;
    const headerTitle = "Summary";
    const previous = "Previous";
    const next = "Submit";
    disabled = this.props.disabled;
    if (this.props.disabled == true) {
      btnBackdisabled = true;
    } else {
      btnBackdisabled = false;
    }

    return (
      <div className="col-lg-12">
        <Panel hasTitle={true} title={headerTitle}>
          <h3>Site Details</h3>
          <div className="task-content">
            <ul className="task-list">
              <li>
                <b>Site Name:</b>
                {this.props.fieldValues.siteName}
              </li>
              <li>
                <b>Site Domain:</b>
                {this.props.fieldValues.siteDomain}
              </li>
              <li>
                <b>Logo filename:</b>
                {this.props.fieldValues.filename}
              </li>
              <li>
                <b>Site Status:</b>
                {this.props.fieldValues.siteStatus}
              </li>
              <li>
                <b>PayVibe Commission % Of Adjusted Gross: </b>
                {this.props.fieldValues.commissionPercent} %
              </li>
              <li>
                <b>PayVibe Commission % of Net: </b>
                {this.props.fieldValues.payVibeCommissionNet} %
              </li>
              <li>
                <b>PayVibe Monthly Fee: </b>${" "}
                {this.props.fieldValues.monthlyFee}
              </li>
              <li>
                <b>PayVibe Minimum Monthly Fee: </b>${" "}
                {this.props.fieldValues.minMonthlyFee}
              </li>
              <li>
                <b>Invoice due date: </b>
                {this.props.fieldValues.invoiceDueDate} days
              </li>
              <li>
                <b>Contracts URL: </b>
                {this.props.fieldValues.signed_nda_link}
              </li>
            </ul>
          </div>
          <h3>Site Admin Details</h3>
          <div className="task-content">
            <ul className="task-list">
              <li>
                <b>User Name:</b> {this.props.fieldValues.userName}
              </li>
              <li>
                <b>Email:</b> {this.props.fieldValues.email}
              </li>
              <li>
                <b>First Name:</b> {this.props.fieldValues.firstName}
              </li>
              <li>
                <b>Last Name:</b> {this.props.fieldValues.lastName}
              </li>
              <li>
                <b>Date of Birth:</b> {this.props.fieldValues.dob}
              </li>
              <li>
                <b>Gender:</b> {this.props.fieldValues.gender}
              </li>
              <li>
                <b>Phone:</b> {this.props.fieldValues.phone}
              </li>
              <li>
                <b>Address1:</b> {this.props.fieldValues.address1}
              </li>
              <li>
                <b>Address2:</b> {this.props.fieldValues.address2}
              </li>
              <li>
                <b>Country:</b> {this.props.fieldValues.countryName}
              </li>
              <li>
                <b>State:</b> {this.props.fieldValues.state}
              </li>
              <li>
                <b>City:</b> {this.props.fieldValues.city}
              </li>
              <li>
                <b>City Id:</b> {this.props.fieldValues.cityID}
              </li>
              <li>
                <b>Zipcode:</b> {this.props.fieldValues.zipcode}
              </li>
              <li>
                <b>User status:</b> {this.props.fieldValues.userStatus}
              </li>
            </ul>
          </div>
          <h3>Company Address</h3>
          <div className="task-content">
            <ul className="task-list">
              <li>
                <b>Country:</b> {this.props.fieldValues.locCountryName}
              </li>
              <li>
                <b>State:</b> {this.props.fieldValues.locStateName}
              </li>
              <li>
                <b>City:</b> {this.props.fieldValues.locCity}
              </li>
              <li>
                <b>City Id:</b> {this.props.fieldValues.loccityID}
              </li>
              <li>
                <b>Address1:</b> {this.props.fieldValues.locAddress1}
              </li>
              <li>
                <b>Address2:</b> {this.props.fieldValues.locAddress2}
              </li>
              <li>
                <b>Latitude:</b> {this.props.fieldValues.locLatitude}
              </li>
              <li>
                <b>Longitude:</b> {this.props.fieldValues.locLongitude}
              </li>
              <li>
                <b>Phone:</b> {this.props.fieldValues.locPhone}
              </li>
              {/* <li>
                <b>Is Location Basic:</b>{" "}
                {this.props.fieldValues.isLocationBasic}
              </li> */}
              <li>
                <b>Location By:</b> {this.props.fieldValues.siteDealMethod}
              </li>
            </ul>
          </div>
          <h3>Database Detail</h3>
          <div className="task-content">
            <ul className="task-list">
              <li>
                <b>Hostname:</b> {this.props.fieldValues.hostname}
              </li>
              <li>
                <b>Database Name:</b> {this.props.fieldValues.db_name}
              </li>
              <li>
                <b>Dataabse User Name:</b> {this.props.fieldValues.db_user}
              </li>
              <li>
                <b>Database Password:</b> {this.props.fieldValues.db_password}
              </li>
            </ul>
          </div>
          <h3>Active Contract/Proposal Type</h3>
          <div className="task-content">
            <ul className="task-list">
              {this.props.fieldValues.ProposalType.indexOf(1) !== -1 && (
                <li>
                  <b>Standard Merchant</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(2) !== -1 && (
                <li>
                  <b>Premium Merchant</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(3) !== -1 && (
                <li>
                  <b>Products</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(4) !== -1 && (
                <li>
                  <b>Travel</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(5) !== -1 && (
                <li>
                  <b>Events</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(6) !== -1 && (
                <li>
                  <b>Coupon Offer</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(7) !== -1 && (
                <li>
                  <b>Affiliate Offer</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(8) !== -1 && (
                <li>
                  <b>Gift Card Vouchers</b>
                </li>
              )}
              {this.props.fieldValues.ProposalType.indexOf(9) !== -1 && (
                <li>
                  <b>Recurring Billing</b>
                </li>
              )}
            </ul>
          </div>
          <h3>Stripe Zero Merchant Remittance Fee</h3>
          <div className="task-content">
            <ul className="task-list">
              <li>
                <b>Checked: </b>
                {this.props.fieldValues.ischecked}
              </li>
              <li>
                <b>Stripe Zero Merchant Remittance Fee(%): </b>
                {this.props.fieldValues.application_fee}
              </li>
            </ul>
          </div>
          <div className="form-footer">
            <Button
              bsStyle="success"
              className="btn -default pull-left"
              disabled={btnBackdisabled}
              onClick={this.previousStep.bind(this)}
            >
              Back
            </Button>
            <Button
              bsStyle="info"
              className="btn -default pull-right"
              disabled={disabled}
              onClick={this.props.submit}
            >
              Submit
            </Button>
          </div>
        </Panel>
      </div>
    );
  }
}

export default StepFour;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/steps/StepFour.js